import styled from 'styled-components';
import { SecondaryButton } from 'styles/elements/buttons/primaryCare';
import { Div } from 'styles/elements/div';
import Textarea from 'styles/elements/textarea';
import media from 'styles/media';

const Preview = styled(Div)`
  margin-bottom: 15px;
`;

const RemoveButton = styled(SecondaryButton)`
  border: none;
  align-self: flex-end;
  margin: 0;
  padding: 0;
  background: none;
`;

const PreviewImage = styled.img`
  height: 100px;
  width: 100px;
  object-fit: contain;
  border: 1px dotted #d2d2d2;
  margin: 1em 100px 0 0;
  ${media.extraSmallAndBelow`
    margin-right: 15px;
    width: 75px;
    height:75px;
  `}
`;

const Text = styled.p`
  margin-top: 0;
`;

const TextBox = styled(Textarea)`
  height: 100px;
  ${media.extraSmallAndBelow`
    height: 50px;
  `}
`;

Preview.RemoveButton = RemoveButton;
Preview.PreviewImage = PreviewImage;
Preview.Text = Text;
Preview.Textarea = TextBox;

export default Preview;
